export const MAGIC_LINK_PRIMARY = "#39797A";

export const MAGIC_LINK_CTA = "#54A4A6";

export const magicLinkColors = {
  textStrong: "#232323",
  text: "#4F4F4F",
  textMuted: "#666666",
  surface: "#FFFFFF",
  page: "#F9FAFC",
  option: "#F9FAFC",
  optionActive: "#F6F6F6",
  border: "#F2F2F2",
  divider: "#E0E0E0",
  disabled: "#E0E0E0"
};

export const magicLinkRadius = {
  button: 4,
  card: 8
};

export const magicLinkLayout = {
  headerHeight: 64,
  footerHeight: 50,
  contentMaxWidth: 1056
};

export const alignedGutter = (minGutter: number) =>
  `max(${minGutter}px, calc((100% - ${magicLinkLayout.contentMaxWidth}px) / 2))`;
